import { ScreenRoot, UsersRoot } from "types";

export const UsersRootDefinition: ScreenRoot = {
  name: UsersRoot,
  routePath: ["/users/*"],
  accessPath: "user",
};
